import { Link } from 'react-router-dom'
import { BUSINESS } from '../../constants/business'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-brand-cream border-t border-gray-200 text-brand-charcoal">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <img src="/photos/fremont-logo-blue.png" alt="Fremont Auto Tech" className="h-10 w-auto object-contain" />
              <span className="text-xl font-black text-brand-charcoal group-hover:text-brand-blue transition-colors duration-200 leading-none" style={{ fontFamily: "'Oswald', sans-serif", letterSpacing: '-0.02em' }}>
                FREMONT AUTO TECH
              </span>
            </Link>
            <p className="text-brand-gray text-xs mb-1">{BUSINESS.nameKorean}</p>
            <p className="text-brand-gray text-xs mb-2">Est. 1992 &middot; A+ BBB Rating</p>
            <p className="text-brand-gray text-sm leading-relaxed mb-4">{BUSINESS.tagline}</p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-brand-charcoal text-sm uppercase tracking-widest mb-4">Our Services</h4>
            <ul className="space-y-2">
              {['Oil Changes', 'Brake Repair', 'Engine Diagnostics', 'Transmission', 'AC & Heating', 'Steering & Suspension'].map((service) => (
                <li key={service}>
                  <a href={`tel:${BUSINESS.phone}`} className="text-brand-gray text-sm hover:text-brand-blue transition-colors duration-200">{service}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-brand-charcoal text-sm uppercase tracking-widest mb-4">Navigate</h4>
            <ul className="space-y-2">
              {[{ label: 'Home', href: '/' }, { label: 'About', href: '/about' }, { label: 'Reviews', href: '/reviews' }, { label: 'Blog', href: '/blog' }].map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-brand-gray text-sm hover:text-brand-blue transition-colors duration-200">{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-brand-charcoal text-sm uppercase tracking-widest mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href={BUSINESS.googleMapsUrl} target="_blank" rel="noopener noreferrer" className="flex items-start gap-2 text-brand-gray text-sm hover:text-brand-blue transition-colors duration-200">
                  <svg className="w-4 h-4 mt-0.5 flex-shrink-0 text-brand-blue" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                  <span>{BUSINESS.address.full}</span>
                </a>
              </li>
              <li>
                <a href={`tel:${BUSINESS.phone}`} className="flex items-center gap-2 text-brand-gray text-sm hover:text-brand-blue transition-colors duration-200">
                  <svg className="w-4 h-4 flex-shrink-0 text-brand-blue" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                  </svg>
                  {BUSINESS.phoneFormatted}
                </a>
              </li>
              <li>
                <div className="flex items-start gap-2 text-brand-gray text-sm">
                  <svg className="w-4 h-4 mt-0.5 flex-shrink-0 text-brand-blue" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                  </svg>
                  <span>Mon-Fri 9AM-6:30PM &middot; Sat 9AM-5PM &middot; Sun Closed</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-brand-gray text-xs text-center md:text-left">
              &copy; {currentYear} Fremont Auto Tech. All rights reserved. &middot; {BUSINESS.address.full}
            </p>
            <div className="flex items-center gap-4">
              <a href={BUSINESS.yelpUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 hover:opacity-80 transition-opacity">
                <img src="/photos/yelp-logo.webp" alt="Yelp" className="w-5 h-5 rounded-full" />
                <span className="text-brand-gray text-xs font-semibold">Yelp</span>
              </a>
              <a href={BUSINESS.googleMapsUrl} target="_blank" rel="noopener noreferrer" className="text-brand-gray text-xs hover:text-brand-blue transition-colors">
                Google Maps
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
